import React, { useState } from 'react'
import { IoHomeSharp } from "react-icons/io5";
import { FaCopy } from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import LogoReact from '../img/science.png'
import LogoHTML from '../img/pngegg.png'
import LogoJS from '../img/pngaaa.com-2497364.png'
import { LogoLanguage, ClearCode, HomeIcon, CodesJS, CodesHTML, CodesReact, LogoMenu } from '../features/SettingSlice'
import { useDispatch, useSelector } from 'react-redux';
import { FaFilePdf } from "react-icons/fa6";
import { FaMicrophone } from "react-icons/fa6";
import { jsPDF } from "jspdf";
function Tollbar() {

    const dispatch = useDispatch()
    const [SelectJs, setSelectJs] = useState('0px')
    const [SelectHtml, setSelectHtml] = useState('0px')
    const [SelectReact, setSelectReact] = useState('0px')
    const codeValue = useSelector((state) => state.setting.CodeValue)

    function ClearPage() {
        dispatch(ClearCode(true))
    }

    function GoHome() {
        dispatch(HomeIcon(true))
    }
    function ShowPanel() {
        dispatch(LogoMenu(true))
    }

    const doc = new jsPDF();
    function PdfFile() {


        doc.text(codeValue, 10, 10);
        doc.save("a4.pdf");
    }

    const [text, setText] = useState('');
    const [listening, setListening] = useState(false);

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();

  recognition.lang = 'en-US';

  recognition.continuous = true;



  recognition.onresult = (event) => {
        const transcript = event.results[event.results.length - 1][0].transcript;
        setText(transcript);
    };



    function MicrophoneActive() {
        setListening(true);
        recognition.start();
    }
    console.log(text)


    function JSlogo() {
        dispatch(LogoLanguage('js'))
        dispatch(CodesJS(true))
        setSelectJs('5px')
        setSelectHtml('0px')
        setSelectReact('0px')

    }
    function HTMLlogo() {
        dispatch(LogoLanguage('html'))
        dispatch(CodesHTML(true))
        setSelectJs('0px')
        setSelectHtml('5px')
        setSelectReact('0px')
    }
    function ReactLogo() {
        dispatch(LogoLanguage('react'))
        dispatch(CodesReact(true))
        setSelectJs('0px')
        setSelectHtml('0px')
        setSelectReact('5px')
    }

    return (
        <>
            <div className='ToolBar'>

                <IoHomeSharp className='icon' onClick={GoHome} />
                <FaCopy className='icon' onClick={ClearPage} />
                <IoMenu className='icon' onClick={ShowPanel} />
                <FaFilePdf className='icon' onClick={PdfFile} />
                <FaMicrophone className='icon' onClick={MicrophoneActive} />

                <img src={LogoJS} style={{ width: '35px', borderBottom: `${SelectJs} solid  rgb(1, 22, 39)`, transitionDuration: '0.3s', borderRadius: '5px' }} className='Langicon' alt="" onClick={JSlogo} />
                <img src={LogoHTML} style={{ width: '35px', borderBottom: `${SelectHtml} solid  rgb(1, 22, 39)`, transitionDuration: '0.3s', borderRadius: '5px' }} className='Langicon' alt="" onClick={HTMLlogo} />
                <img src={LogoReact} style={{ width: '35px', borderBottom: `${SelectReact} solid  rgb(1, 22, 39)`, transitionDuration: '0.3s', borderRadius: '5px' }} className='Langicon' alt="" onClick={ReactLogo} />
            </div>

        </>
    )
}

export default Tollbar